import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/views/layout/Layout";

export const constantRouterMap = [
  // {
  //   path: "/login",
  //   component: () => import("@/views/login/index"),
  //   hidden: true
  // },
  // {
  //   path: "/auth-redirect",
  //   component: () => import("@/views/login/authredirect"),
  //   hidden: true
  // },
  {
    path: "/signin",
    component: () => import("@/views/login/saisiyun"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    redirect: "dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "dashboard",
        meta: {
          title: "首页",
          icon: "dashboard",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/profile",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "info",
        component: () => import("@/views/dashboard/profile"),
        name: "Profile",
        meta: {
          title: "账户信息",
          noCache: true
        }
      },
      {
        path: "changePassword",
        component: () => import("@/views/dashboard/change_password"),
        name: "ChangePassword",
        meta: {
          title: "修改密码",
          noCache: true
        }
      }
    ]
  }
];

export const page_error = [
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true
  },
  {
    path: "*",
    redirect: "/",
    hidden: true
  }
];

const createRouter = () => new Router({
  // mode: "history",
  // base: "/zz-backend",
  // mode: 'hash', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

export const asyncRouterMap = [
  {
    path: "/clue",
    component: Layout,
    redirect: "/clue/clue-index",
    name: "Clue",
    meta: {
      title: "线索池",
      icon: "nested"
    },
    children: [
      {
        path: "clue-index",
        component: () => import("@/views/clue/index"),
        name: "ClueIndex",
        meta: {
          title: "线索池"
        }
      },
      // {
      //   path: "clue-list",
      //   component: () => import("@/views/clue/clue-list"),
      //   name: "ClueList",
      //   meta: {
      //     title: "线上线索"
      //   }
      // },
      // {
      //   path: "store-list",
      //   component: () => import("@/views/clue/store-list"),
      //   name: "StoreList",
      //   meta: {
      //     title: "线下线索"
      //   }
      // },
      // {
      //   path: "publicClue-list",
      //   component: () => import("@/views/clue/publicClue-list"),
      //   name: "DealerPublicClueList",
      //   meta: {
      //     title: "品牌线索池"
      //   }
      // }
    ]
  },
  {
    path: "/dealer",
    component: Layout,
    redirect: "/dealer/dealer-list",
    name: "Dealer",
    meta: {
      title: "经销商",
      icon: "nested"
    },
    children: [
      {
        path: "dealer-list",
        component: () => import("@/views/dealer/list"),
        name: "DealerList",
        meta: {
          title: "经销商列表"
        }
      },
      // {
      //   path: "approve-list",
      //   component: () => import("@/views/dealer/approve"),
      //   name: "DealerApproveList",
      //   meta: {
      //     title: "经销商申请"
      //   }
      // },
      // {
      //   path: "customerApplication",
      //   component: () => import("@/views/dealer/customerApplication"),
      //   name: "CustomerApplication",
      //   meta: {
      //     title: "即客申请"
      //   }
      // },
      {
        path: "dealer-user-list",
        component: () => import("@/views/dealer/users"),
        name: "DealerUserList",
        meta: {
          title: "经销商成员"
        }
      },
      {
        path: "customer-list",
        component: () => import("@/views/dealer/customer-list"),
        name: "DealerCustomerList",
        meta: {
          title: "经销商客户"
        }
      },
      {
        path: "salesOrder-list",
        component: () => import("@/views/dealer/salesOrder-list"),
        name: "SalesOrderList",
        meta: {
          title: "经销商订单"
        }
      }
    ]
  },
  {
    path: "/report",
    component: Layout,
    redirect: "/report/assess-indicator",
    name: "Statistics",
    meta: {
      title: "统计报表",
      icon: "nested"
    },
    children: [
      {
        path: "assess-indicator",
        component: () => import("@/views/statistics/index"),
        name: "StatisticsIndex",
        meta: {
          title: "核心五率"
        }
      },
    ]
  },
  {
    path: "/vehicle",
    component: Layout,
    redirect: "/vehicle/series-list",
    name: "Vehicle",
    meta: {
      title: "车型管理",
      icon: "nested"
    },
    children: [
      {
        path: "series-list",
        component: () => import("@/views/vehicle/series"),
        name: "VehicleSeriesList",
        meta: {
          title: "车系车型"
        }
      },
      {
        path: "spec-list",
        component: () => import("@/views/vehicle/spec"),
        name: "VehicleSpecList",
        meta: {
          title: "物料配置"
        }
      },
      {
        path: "online-spec-mapping",
        component: () => import("@/views/vehicle/online_mapping"),
        name: "OnlineSpecMapping",
        meta: {
          title: "线索车型映射"
        }
      },
      // {
      //   path: "series30List",
      //   component: () => import("@/views/vehicle/series30"),
      //   name: "Series30List",
      //   meta: {
      //     title: "3.0车系配置"
      //   }
      // },
      // {
      //   path: "seriesManage",
      //   component: () => import("@/views/vehicle/seriesManage"),
      //   name: "SeriesManage",
      //   meta: {
      //     title: "车系组维护"
      //   }
      // }
    ]
  },
  // {
  //   path: "/report",
  //   component: Layout,
  //   redirect: "/report/dealer-summary",
  //   name: "Report",
  //   meta: {
  //     title: "统计报表",
  //     icon: "nested"
  //   },
  //   children: [
  //     // {
  //     //   path: "abnormal-summary",
  //     //   component: () => import("@/views/report/abnormal-summary"),
  //     //   name: "ReportAbnormalSummary",
  //     //   meta: {
  //     //     title: "下发异常统计"
  //     //   }
  //     // },
  //     {
  //       path: "dealer-summary",
  //       component: () => import("@/views/report/dealer-summary"),
  //       name: "ReportDealerSummary",
  //       meta: {
  //         title: "经销商统计"
  //       }
  //     },
  //     {
  //       path: "fail-summary",
  //       component: () => import("@/views/report/fail-summary"),
  //       name: "ReportFailSummary",
  //       meta: {
  //         title: "战胜战败统计"
  //       }
  //     },
  //     {
  //       path: "guest-summary",
  //       component: () => import("@/views/report/InstantGuest-summary"),
  //       name: "ReportGuestSummary",
  //       meta: {
  //         title: "即客统计"
  //       }
  //     },
  //     {
  //       path: "login-summary",
  //       component: () => import("@/views/report/login-summary"),
  //       name: "ReportLoginSummary",
  //       meta: {
  //         title: "登录统计"
  //       }
  //     },
  //     {
  //       path: "export-summary",
  //       component: () => import("@/views/report/export-summary"),
  //       name: "ExportSummary",
  //       meta: {
  //         title: "商家导出日志"
  //       }
  //     },
  //     {
  //       path: "clue-region-summary",
  //       component: () => import("@/views/report/clue-region-summary"),
  //       name: "ReportAbnormalSummary",
  //       meta: {
  //         title: "转介绍线索"
  //       }
  //     },
  //   ]
  // },
  {
    path: "/help",
    component: Layout,
    redirect: "/help/bydIndex",
    name: "Helps",
    meta: {
      title: "帮助中心",
      icon: "dashboard"
    },
    children: [
      {
        path: "bydIndex",
        name: "bydHelp",
        component: () => import("@/views/help/byd"),
        meta: {
          title: "智蛛帮助中心"
        }
      },
      {
        path: "bydArticle",
        name: "byd-Article",
        hidden: true,
        component: () => import("@/views/help/byd/article"),
        meta: {
          title: "智蛛编辑文章"
        },
        authPath: 'bydIndex'
      }
    ]
  },
  {
    path: "/system",
    component: Layout,
    redirect: "/system/role/list",
    name: "System",
    meta: {
      title: "平台管理",
      icon: "nested"
    },
    children: [
      {
        path: "user/list",
        component: () => import("@/views/system/user/list"),
        name: "SystemUserList",
        meta: {
          title: "操作员管理"
        }
      },
      {
        path: "role/list",
        component: () => import("@/views/system/role/list"),
        name: "SystemRoleList",
        meta: {
          title: "角色管理"
        }
      },
      {
        path: "role/add",
        component: () => import("@/views/system/role/add"),
        name: "SystemRoleAdd",
        meta: {
          title: "添加角色"
        },
        hidden: true,
        authPath: 'role/list'
      },
      {
        path: "role/edit/:id",
        component: () => import("@/views/system/role/edit"),
        name: "SystemRoleEdit",
        meta: {
          title: "角色编辑"
        },
        hidden: true,
        authPath: 'role/list'
      },
      {
        path: "functions/list",
        component: () => import("@/views/system/functions/list"),
        name: "SystemFunctions",
        meta: {
          title: "功能管理"
        }
      },
      {
        path: "functions/add",
        component: () => import("@/views/system/functions/add"),
        name: "SystemFunctionsAdd",
        meta: {
          title: "添加功能"
        },
        hidden: true,
        authPath: 'functions/list'
      },
      {
        path: "functions/edit/:id",
        component: () => import("@/views/system/functions/edit"),
        name: "SystemFunctionsEdit",
        meta: {
          title: "功能编辑"
        },
        hidden: true,
        authPath: 'functions/list'
      },
      {
        path: "data",
        component: () => import("@/views/system/dictionary/list"),
        name: "SystemDictionaryList",
        meta: {
          title: "数据字典"
        }
      },
      {
        path: "exportJob",
        component: () => import("@/views/system/exportJob/list"),
        name: "SystemExportJobList",
        meta: {
          title: "导出任务"
        }
      },
      // {
      //   path: "appVersions",
      //   component: () => import("@/views/system/appVersion/list"),
      //   name: "SystemAppVersionList",
      //   meta: {
      //     title: "App版本"
      //   }
      // },
      // {
      //   path: "feedback",
      //   component: () => import("@/views/system/feedback/list"),
      //   name: "SystemFeedBackList",
      //   meta: {
      //     title: "意见反馈"
      //   }
      // },
      {
        path: "systemnotification",
        component: () => import("@/views/system/systemnotification/list"),
        name: "SystemNotificationList",
        meta: {
          title: "系统通知"
        }
      },
      {
        path: "competition",
        component: () => import("@/views/system/competition/list"),
        name: "SystemCompetitionList",
        meta: {
          title: "竞品车系"
        }
      },
      // {
      //   path: "identify",
      //   component: () => import("@/views/system/identify/list"),
      //   name: "SystemIdentify",
      //   meta: {
      //     title: "身份认证"
      //   }
      // },
      // {
      //   path: "workweixin",
      //   component: () => import("@/views/system/workweixin/list"),
      //   name: "SystemWorkWeixinList",
      //   meta: {
      //     title: "微信通讯录"
      //   }
      // }
    ]
  }
];
